
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultations/experts",
      function () {
        return require("private-next-pages/consultations/experts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consultations/experts"])
      });
    }
  